import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';  // react-i18next를 사용하여 i18n 처리
import './AppHeaderLanguage.css';

const AppHeaderLanguage = () => {
  const { i18n } = useTranslation(); // i18n 객체 가져오기
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language); // 초기 언어 설정

  const changeLanguage = (event) => {
    const language = event.target.value;
    setSelectedLanguage(language); // 선택된 언어 업데이트
    i18n.changeLanguage(language); // i18n의 언어 변경
  };

  return (
    <div className="div-language-select">
      <i className="fas fa-globe"></i>
      <select 
        id="language-select" 
        value={selectedLanguage} 
        onChange={changeLanguage}
      >
        <option value="en">English</option>
        <option value="ko">한국어</option>
        <option value="ja">日本語</option>
      </select>
    </div>
  );
};

export default AppHeaderLanguage;
